import { createFileRoute } from "@tanstack/react-router";
import { DataIntelligenceServicePage } from "./services_.data-intelligence";

export const Route = createFileRoute("/services_/data-intelligence-services")({
  head: () => ({
    meta: [
      {
        title: "Data Intelligence Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Consumer Insights & Predictive Data Modeling.",
      },
    ],
  }),
  component: DataIntelligenceServicePage,
});
